export enum EsploroAssetDateType {
    DATE_DEGREE = 'DATE_DEGREE',
    DATE_PUBLISHED = 'DATE_PUBLISHED',
    DATE_EPUBLISHED = 'DATE_EPUBLISHED',
    DATE_COPYRIGHTED = 'DATE_COPYRIGHTED',
    DATE_POSTED = 'DATE_POSTED',
    DATE_AVAILABLE = 'DATE_AVAILABLE',
    DATE_PRESENTED = 'DATE_PRESENTED',
    DATE_OPENING = 'DATE_OPENING',
    DATE_PERFORMANCE = 'DATE_PERFORMANCE',
    DATE_VALID = 'DATE_VALID',
    DATE_ISSUED = 'DATE_ISSUED',
    DATE_RENEWED = 'DATE_RENEWED',
    DATE_APPROVED = 'DATE_APPROVED',
    DATE_ACCEPTED = 'DATE_ACCEPTED',
    DATE_DEFENSE = 'DATE_DEFENSE',
    DATE_SUBMITTED = 'DATE_SUBMITTED',
    DATE_APPLICATION = 'DATE_APPLICATION',
    DATE_COMPLETED = 'DATE_COMPLETED',
    DATE_CREATED = 'DATE_CREATED',
    DATE_COLLECTED = 'DATE_COLLECTED',
    DATE_OTHER = 'DATE_OTHER',
    DATE_UPDATED = 'DATE_UPDATED',
}

export interface AssetDates {
    assetDates: { [type in EsploroAssetDateType]: EsploroAssetDateModel };
}

export interface EsploroAssetDateModel {
    dateType: EsploroAssetDateType;
    datesList: string[];
    season: string;
}

export interface StatusUpdatesModel {
    statusUpdates?: StatusUpdates[]
}

export interface StatusUpdates {
    updatedTo: string;
    updateDate: FullDateSpliceFormat;
    updatedBy: string;
}

export interface FullDateSpliceFormat {
    year: number;
    month: number;
    dayOfMonth: number;
    hourOfDay: number;
    minute: number;
    second: number;
}

export const getAssetDatesListByPriority = (dateMap) => {
    const type = EsploroAssetDateType;
    let dateObj = { datesList: undefined };

    if (dateMap?.[type.DATE_DEGREE]) {
        dateObj = dateMap[type.DATE_DEGREE];
    } else if (dateMap?.[type.DATE_PUBLISHED]) {
        dateObj = dateMap[type.DATE_PUBLISHED];
    } else if (dateMap?.[type.DATE_EPUBLISHED]) {
        dateObj = dateMap[type.DATE_EPUBLISHED];
    } else if (dateMap?.[type.DATE_COPYRIGHTED]) {
        dateObj = dateMap[type.DATE_COPYRIGHTED];
    } else if (dateMap?.[type.DATE_POSTED]) {
        dateObj = dateMap[type.DATE_POSTED];
    } else if (dateMap?.[type.DATE_AVAILABLE]) {
        dateObj = dateMap[type.DATE_AVAILABLE];
    } else if (dateMap?.[type.DATE_PRESENTED]) {
        dateObj = dateMap[type.DATE_PRESENTED];
    } else if (dateMap?.[type.DATE_OPENING]) {
        dateObj = dateMap[type.DATE_OPENING];
    } else if (
        dateMap?.[type.DATE_PERFORMANCE] &&
        dateMap[type.DATE_PERFORMANCE].datesList[0]
    ) {
        dateObj = dateMap[type.DATE_PERFORMANCE];
    } else if (dateMap?.[type.DATE_VALID]) {
        dateObj = dateMap[type.DATE_VALID];
    } else if (dateMap?.[type.DATE_ISSUED]) {
        dateObj = dateMap[type.DATE_ISSUED];
    } else if (dateMap?.[type.DATE_RENEWED]) {
        dateObj = dateMap[type.DATE_RENEWED];
    } else if (dateMap?.[type.DATE_APPROVED]) {
        dateObj = dateMap[type.DATE_APPROVED];
    } else if (dateMap?.[type.DATE_ACCEPTED]) {
        dateObj = dateMap[type.DATE_ACCEPTED];
    } else if (dateMap?.[type.DATE_DEFENSE]) {
        dateObj = dateMap[type.DATE_DEFENSE];
    } else if (dateMap?.[type.DATE_SUBMITTED]) {
        dateObj = dateMap[type.DATE_SUBMITTED];
    } else if (dateMap?.[type.DATE_APPLICATION]) {
        dateObj = dateMap[type.DATE_APPLICATION];
    } else if (dateMap?.[type.DATE_COMPLETED]) {
        dateObj = dateMap[type.DATE_COMPLETED];
    } else if (dateMap?.[type.DATE_CREATED]) {
        dateObj = dateMap[type.DATE_CREATED];
    } else if (dateMap?.[type.DATE_COLLECTED]) {
        dateObj = dateMap[type.DATE_COLLECTED];
    } else if (
        dateMap?.[type.DATE_OTHER] &&
        dateMap[type.DATE_OTHER].datesList[0]
    ) {
        dateObj = dateMap[type.DATE_OTHER];
    } else if (
        dateMap?.[type.DATE_UPDATED] &&
        dateMap[type.DATE_UPDATED].datesList[0]
    ) {
        dateObj = dateMap[type.DATE_UPDATED];
    }
    return dateObj.datesList;
};
